import type { IdentityClaims } from "@istari-frontend/auth";

import { PLATFORM_ADMIN_ROLE, type Session, TENANT_ADMIN_ROLE } from "../model/session";

/** The v2 path: everything comes from the token's claims, no request is made. */
export function deriveSessionFromClaims(claims: IdentityClaims): Omit<Session, "mode" | "isLoading"> {
  const isPlatformAdmin = claims.platformRoles.includes(PLATFORM_ADMIN_ROLE);
  const tenantAdminHere = claims.tenantId !== undefined && claims.tenantRoles.includes(TENANT_ADMIN_ROLE);
  return {
    principalId: claims.principalId,
    principalKind: claims.principalKind,
    tenantId: claims.tenantId,
    tenantSlug: claims.tenantSlug,
    upstreamUserId: claims.upstreamUserId,
    upstreamTenantId: claims.upstreamTenantId ?? claims.zitadelOrganizationId,
    platformRoles: claims.platformRoles,
    tenantRoles: claims.tenantRoles,
    isPlatformAdmin,
    isTenantAdminOf: (tenantId) => isPlatformAdmin || (tenantAdminHere && tenantId === claims.tenantId),
    administeredTenants: isPlatformAdmin
      ? { all: true }
      : { all: false, tenantIds: tenantAdminHere ? [claims.tenantId as string] : [] },
  };
}
